import { UpperCasePipe } from '@angular/common';
import { Component, inject, input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';

import { CookieService } from 'ngx-cookie-service';

import { Constants } from '@shared/constants';
import { CapitalizePipe } from '@shared/pipes/capitalize.pipe';
import { LocalePipe } from '@shared/pipes/locale.pipe';

/**
 * language switch component offers the user the ability
 * to change the language of the content.
 *
 * the component is used in {@link ToolbarComponent} and in {@link FooterComponent}
 */
@Component( {
    selector: 'app-language-switch',
    imports: [ MatButtonModule, MatMenuModule, MatIconModule, CapitalizePipe, UpperCasePipe ],
    providers: [ CapitalizePipe, LocalePipe, UpperCasePipe ],
    templateUrl: './language-switch.component.html',
    styleUrl: './language-switch.component.scss'
} )
export class LanguageSwitchComponent {
    /**
     * data binding for vertical position of the language menu
     * @property postion : above or below
     */
    readonly position = input<'above' | 'below'>( 'above' );

    /** flag is language menu is closed */
    isClosed = true;

    /** store current language */
    currentLanguage = '';

    /**
     * list of supported languages
     * used to fill the menu
     */
    languages = Constants.supportedLanguages;
    sortedLanguages: string[][] = [];

    #cookieService = inject( CookieService );
    #localePipe = inject( LocalePipe );

    constructor() {
        this.currentLanguage = this.#cookieService.get( 'language' ) || document.documentElement.lang;

        // create tuple of languages
        this.languages.forEach( ( key ) => {
            const locale = this.#localePipe.transform( key );
            const arr = [ key, locale ];
            this.sortedLanguages.push( arr );
        } );
        // sort tuple according to current language
        const collator = new Intl.Collator( this.currentLanguage );
        this.sortedLanguages.sort( ( a, b ) => collator.compare( a[ 1 ], b[ 1 ] ) );
    }

    /**
     * helper function to switch app language
     *
     * when selected language differs from current language
     * then choosen language is populated through shared service
     * set / updates in cookie
     * and page should reload
     * @param lang string
     */
    changeLanguage( lang: string ) {
        const languageChanged = lang !== this.currentLanguage;
        if ( languageChanged ) {
            this.#cookieService.set( 'language', lang.slice( 0, 2 ), undefined, '/' );
            window.location.reload();
        }
    }

    /** helper function to toogle menu state isClosed */
    toogleMenu() {
        this.isClosed = !this.isClosed;
    }
}
